import React, { useContext, useEffect, useState } from 'react';
import { StyledGameTablesContainer } from './GameTables.styled';
import TopBar from './TopBar';
import TableCard from './TableCard';
import { PlayerContext } from '../../contexts/playerContext';
import { getTableList } from '../../utils/getTableList';
import Button from '../Button/Button';
import { game } from '../../store/game';
import { SocketEmit } from '../../types.ds';

interface Props {
    setTablePage: () => void
    setActive: (active: string) => void
    tablePage: number
    pageLimit: number
}

const GameTables = (props: Props) => {
    const playerContext = useContext(PlayerContext);
    const [style, setStyle] = useState<string>("card");
    const [endTablePage, setEndTablePage] = useState<boolean>(false);

    const handleLoadMore = () => {
        props.setTablePage();
        // game.emit[SocketEmit.GetTables]();
    }

    const handleShowAddFundModal = (active: string) => {
        props.setActive(active);
    }

    useEffect(() => {
        if(playerContext?.tableList == undefined) {
            setEndTablePage(true);
            return;
        }
        if(playerContext?.tableList.length > props.tablePage * props.pageLimit) {
            setEndTablePage(false);
        } else {
            setEndTablePage(true);
        }
    }, [props.tablePage, playerContext?.tableList])

    return (
        <StyledGameTablesContainer>
            <TopBar setStyle={setStyle} style={style} />
            <div>
                {
                    playerContext?.tableList && playerContext?.tableList.length > 0 && playerContext?.tableList.slice(0, props.tablePage * props.pageLimit).map((table, index) => (
                        <TableCard table={table} style={style} key={index} setActive={handleShowAddFundModal} />
                    ))
                }
            </div>
            {
                !endTablePage && (
                    <div style={{ display: 'flex', justifyContent: 'center', marginTop: '30px' }}>
                        <Button padding='3rem' textSize='16px' text='Load More' image={null} size='big' event={handleLoadMore} />
                    </div>
                )
            }
        </StyledGameTablesContainer>
    );
}

export default GameTables;
